import { TOAST_TYPE } from 'utils/constants'
import { toastStore } from 'stores/toast'

export function handleWebSocketMessageGeneral(data) {
  if (data.notify) {
    toastStore.createToast(TOAST_TYPE.ALERT, data.payload.text, '')
  }
}
